module.exports = __webpack_public_path__ + "fonts/AntikorMono-News.db3a292d.woff2";